import { ADDRESS_COMPONENTS, CITIES_TYPE, REGIONS_TYPE } from '@/enums';

/**
 * Format result from Geo google APIs
 * @param place
 * @returns {{formatted output}}
 */
export function formatResult(place) {
  // TODO~> better interface
  const returnData: any = {};
  for (let i = 0; i < place.address_components.length; i++) {
    const addressType = place.address_components[i].types[0];
    if (ADDRESS_COMPONENTS[addressType]) {
      const val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
      returnData[addressType] = val;
    }
  }
  returnData.latitude = place.geometry.location.lat();
  returnData.longitude = place.geometry.location.lng();
  return returnData
}

/**
 * Extract configured types out of raw result as
 * Geocode API does not allow to do it
 * @param results
 * @returns {GeocoderResult}
 * @link https://developers.google.com/maps/documentation/javascript/reference#GeocoderResult
 */
export function filterGeocodeResultTypes(results, geoTypes) {
  if (!results || !geoTypes) return results;
  const output: any = [];
  let types = !Array.isArray(geoTypes) ? [geoTypes] : geoTypes;
  if (types.includes('(cities)')) types = types.concat(CITIES_TYPE);
  if (types.includes('(regions)')) types = types.concat(REGIONS_TYPE);
  for (const r of results) {
    for (const t of r.types) {
      if (types.includes(t)) {
        output.push(r);
        break;
      }
    }
  }
  return output;
}
